import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-4 p-4" };
const _hoisted_2 = { class: "flex flex-col gap-2" };
const _hoisted_3 = { class: "text-sm font-semibold text-gray-900" };
const _hoisted_4 = { value: null };
const _hoisted_5 = ["value"];
const _hoisted_6 = { class: "flex items-center justify-between px-4 py-3" };
import { ref, reactive, watch, onMounted, onBeforeUnmount } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FiltersPopover',
    props: {
        services: {},
        modelValue: {}
    },
    emits: ["update:modelValue", "apply", "clear", "close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const popoverRef = ref(null);
        const localFilters = reactive({ ...props.modelValue });
        watch(() => props.modelValue, (val) => Object.assign(localFilters, val), { deep: true });
        function handleApply() {
            const val = { ...localFilters };
            emit("update:modelValue", val);
            emit("apply", val);
            emit("close");
        }
        function handleClear() {
            localFilters.serviceId = null;
            emit("update:modelValue", { ...localFilters });
            emit("clear");
            emit("close");
        }
        function handleOutsideClick(e) {
            if (popoverRef.value && !popoverRef.value.contains(e.target)) {
                emit("close");
            }
        }
        onMounted(() => document.addEventListener("mousedown", handleOutsideClick));
        onBeforeUnmount(() => document.removeEventListener("mousedown", handleOutsideClick));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "popoverRef",
                ref: popoverRef,
                class: "absolute z-50 bg-white border border-gray-200 rounded-lg shadow-lg w-80",
                style: { "top": "calc(100% + 8px)", "right": "0" }
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("reservations.auto.servicio")), 1),
                        _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((localFilters.serviceId) = $event)),
                            class: "w-full px-3 text-sm text-gray-700 bg-white border border-gray-200 rounded-md h-9 focus:outline-none focus:ring-2 focus:ring-eorange-400 focus:border-transparent"
                        }, [
                            _createElementVNode("option", _hoisted_4, _toDisplayString(_ctx.$t("reservations.auto.seleccionar_servicio")), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.services, (svc) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: svc.id,
                                    value: svc.id
                                }, _toDisplayString(svc.name), 9, _hoisted_5));
                            }), 128))
                        ], 512), [
                            [_vModelSelect, localFilters.serviceId]
                        ])
                    ])
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "h-px bg-gray-100" }, null, -1)),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "text-sm font-medium text-gray-500 transition-colors hover:text-gray-700",
                        onClick: handleClear
                    }, _toDisplayString(_ctx.$t("reservations.auto.limpiar_filtros")), 1),
                    _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex items-center h-8 px-4 text-sm font-semibold text-white transition-colors rounded-md bg-eorange-500 hover:bg-eorange-600",
                        onClick: handleApply
                    }, _toDisplayString(_ctx.$t("reservations.auto.aplicar")), 1)
                ])
            ], 512));
        };
    }
});
